export default __webpack_public_path__ + "media/2c8973e100eabf0dac8df5a709feac562197998cea9909d62b009e7fb2dd9c28.svg";